import { Component, Inject, ViewChild } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { SnackbarService } from '../../../services/shared/snackbar/snackbar.service';
import { TranslationService } from '../../../services/translation/translation.service';
import { Page } from '../../../models/page.model';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { DialogService } from '../../../services/shared/dialog/dialog.service';
import { UtilsService } from '../../../services/shared/utils/utils.service';

@Component({
  selector: 'app-page-history-modal',
  templateUrl: './page-history-modal.component.html',
  styleUrl: './page-history-modal.component.css'
})
export class PageHistoryModalComponent {
  totalItems: number;
  isEdited: boolean;
  displayedColumns: string[] = ['updatedDate', 'version', 'actions'];
  dataSource = new MatTableDataSource<Page>();
  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;
  constructor(private dialogRef: MatDialogRef<PageHistoryModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { pageHistories: Page[], isEdited: boolean },
    private snackBar: SnackbarService,
    private translationService: TranslationService,
    private dialogService: DialogService,
    private utilsService: UtilsService) {
    this.dataSource.data = data.pageHistories;
    this.totalItems = data.pageHistories.length;
    this.isEdited = data.isEdited;
  }

  ngAfterViewInit() {
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
  }

  restorePage(page: Page) {
    this.dialogService.confirm(
      this.translationService.translate('Restore'),
      this.translationService.translate('Are you sure you want to replace the current page with an older version?') + ' ' + this.translationService.translate('Any unsaved changes will be lost.')
    )
    .then((confirmed) => {
      if (confirmed) {
        this.dialogRef.close(page);
      }
    });
  }

  onCancel(): void {
    this.dialogRef.close();
  }

  VersionBoldIndex(text: string | undefined): string {
    return this.utilsService.VersionBoldIndex(text);
  }
}
